import React, {useContext} from 'react';
import {observer} from 'mobx-react';
import classnames from 'classnames';
import {bem} from '../../utils/bem';
import DownloadContext from '../../stores/DownloadContext';
import TranslationContext from '../../utils/I18n';
import Block from '../common/Block';
import GridRow from './GridRow';

const block = bem('downgrid');


const DownloadGrid = () => {
	const store = useContext(DownloadContext);
	const t = useContext(TranslationContext);
	const {filteredGrid, grid, downloadTypes} = store;

	if (grid.length < 2) return null;
	return (
		<Block
			modifiers={{
				colorSchemeDefault: true,
				adaptiveGrid: true,
				paddingLeftDefault: true,
				paddingLeftMultiDefault: true,
				paddingRightDefault: true,
				paddingRightMultiDefault: true
			}}
		>
			<div className={block('container')}>
				<div className={classnames(block(), block('content'))}>
					<table className={block('header')}>
						<thead>
						<tr>
							<th className={block('cell', {heading: true, search: true})} colSpan="2" scope="row"/>
							<th className={block('cell', {heading: true, fixed: true})} scope="row">
								<span className={block('rotatedHeading')}>{t('downloads.specsheetpreview')}</span>
							</th>
							{downloadTypes.map(type => (
								<th key={type} className={block('cell', {heading: true, fixed: true})} scope="row">
									<span className={block('rotatedHeading')}>{t(`downloads.${type}`)}</span>
								</th>
							))}
							<th className={block('cell', {heading: true, fixed: true})} scope="row">
								<span className={block('rotatedHeading')}>{t('downloads.all')}</span>
							</th>
						</tr>
						</thead>
					</table>
					<table className={block('table')}>
						<tbody>
						{filteredGrid.map((row, idx) => {
							const lastRow = idx > 0? filteredGrid[idx - 1] : {};
							const isGroupHeader = !!row.group && row.group !== lastRow.group;
							return (
								<GridRow
									row={row}
									isGroupHeader={isGroupHeader}
									store={store}
									key={`${row.label}-${row.idx}-${row.uri}`}
								/>
							);
						})}
						</tbody>
					</table>
				</div>
			</div>
		</Block>
	);
};

export default observer(DownloadGrid);
